import { render, staticRenderFns } from "./DelManagerOverviewHeader.vue?vue&type=template&id=24bc0012&scoped=true&"
import script from "./DelManagerOverviewHeader.vue?vue&type=script&lang=js&"
export * from "./DelManagerOverviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./DelManagerOverviewHeader.vue?vue&type=style&index=0&id=24bc0012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc0012",
  null
  
)

export default component.exports